export default __webpack_public_path__ + "static/media/icon-message-check-green.8afe3d69.svg";